import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';

export enum SearchFilterDateMode {
  SINGLE = 'a_partir_de',
  RANGE = 'intervalo',
}

export type SearchFilterDateValues = Pick<FilterState, 'minDate' | 'maxDate'>;

export const DATE_ANALYTICS_KEY = 'data';

export const DATE_MODE_ANALYTICS_KEY = 'modo_data';

export const DATE_START_ANALYTICS_KEY = 'valor_de';

export const DATE_END_ANALYTICS_KEY = 'valor_ate';
